import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import useProfile from './useProfile';

export const FETCH_COMPACT_WALLET_STATUS = gql`
  query FetchWalletStatus {
    walletStatus {
      hasPwGBCard
      hasPwGBPlusCard
      accountStatus
    }
  }
`;

export default function useSimpleWalletStatus(shouldSkipQuery = false) {
  const { isLoggedIn } = useProfile();
  const { data } = useQuery(FETCH_COMPACT_WALLET_STATUS, {
    skip: !isLoggedIn || shouldSkipQuery,
  });
  return data?.walletStatus;
}
